import React, { createContext, useState, useContext } from "react";

// Create a Context
const DataContext = createContext();

// Context Provider
export const DataProvider = ({ children }) => {
  const [data, setData] = useState(null);

  return (
    <DataContext.Provider value={{ data, setData }}>
      {children}
    </DataContext.Provider>
  );
};

// Custom Hook to Use Context
export const useData = () => useContext(DataContext);
